import type { ReactNode } from "react";
import { Header } from "./Header";
import { useLang } from "../context/LangContext";

export function Layout({ children }: { children: ReactNode }) {
  const { t } = useLang();
  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">{children}</main>
      <footer className="app-footer">
        <span className="muted">
          © {new Date().getFullYear()} Survantic · {t.footerTagline}
        </span>
        <a className="muted-link" href="https://survantic.com" target="_blank" rel="noreferrer">
          survantic.com
        </a>
      </footer>
    </div>
  );
}
